/* @ngInject */
export default function NavigationService($rootScope, $location, $translate, CacheService, QueryApiService, SleuthService, SpinnerLoadingService) {
    function hasChildDefinition(rootDefinition, currentDefinition) {
        if (rootDefinition.id === currentDefinition.id) {
            return true;
        }

        for (let i = 0; i < rootDefinition.childDefinitions.length; ++i) {
            if (rootDefinition.childDefinitions[i].id === currentDefinition.id) {
                return true;
            } else {
                if (hasChildDefinition(rootDefinition.childDefinitions[i], currentDefinition)) {
                    return true;
                }
            }
        }
        return false;
    }

    function hasSyncByParent(definitionId) {
        if (CacheService.getParentDefinition().length !== 0) {
            for (let i = CacheService.getParentDefinition().length - 1; i >= 0; --i) {
                if (CacheService.getParentDefinition()[i].id == definitionId) {
                    CacheService.storeDefinition(CacheService.getParentDefinition()[i]);
                    CacheService.getParentDefinition().length = i;
                    return true;
                }
            }
        }

        return false;
    }

    function hasSyncByChildren(definitionId) {
        for (let i = 0; i < CacheService.getDefinition().childDefinitions.length; ++i) {
            if (CacheService.getDefinition().childDefinitions[i].id == definitionId) {
                CacheService.storeParentDefinition(CacheService.getDefinition());
                CacheService.storeDefinition(CacheService.getDefinition().childDefinitions[i]);
                return true;
            }
        }
        return false;
    }

    function syncFromRootDefinitions(definitionId) {
        console.log(SleuthService);
        let rootDefinitions;
        if (SleuthService.getSleuthData() !== undefined) {
            rootDefinitions = SleuthService.getSleuthData().detectedDefinitions;
        } else {
            rootDefinitions = CacheService.getAllDefinitions();
        }
        for (let i = 0; i < rootDefinitions.length; ++i) {
            CacheService.getParentDefinition().length = 0;
            const definition = getCurrentDefinition(rootDefinitions[i], definitionId);
            if (definition != null) {
                CacheService.storeDefinition(definition);
                break;
            }
        }
    }

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return undefined;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function isParmValueIdsDifferent(oldParams, newParams) {
        if(oldParams.length !== newParams.length) {
            return true;
        }

        var found = false;
        for(var i=0;i<oldParams.length;++i) {
            for(var j=0;j<newParams.length;++j) {
                if(oldParams[i] === newParams[j]) {
                    found = true;
                }

            }
            if(!found) {
                return true;
            }
        }
        return false;
    }

    function getParamValueIds(url) {
        var results = [];
        if (!url) url = window.location.href;
        var regex = new RegExp('[?&]' + 'parmValueIds' + '(=([^&#]*)|&|#|$)', 'g'),
            result = regex.exec(url);
        var failSafety = 0;
        while(result != null) {
            failSafety++;
            if(result[2]) {
                results.push(decodeURIComponent(result[2].replace(/\+/g, ' ')));
            }
            result = regex.exec(url);
            if(failSafety > 1000) {
                break;
            }
        }
        return results;
    }

    function getCurrentDefinition(definition, definitionId) {
        // Sometimes there is no definitionId, even when there is one in the URL.
        if (definitionId) {
            if (definition.id == definitionId) {
                return definition;
            }
        }

        let i;
        for (i = 0; i < definition.childDefinitions.length; ++i) {
            if (definition.childDefinitions[i].id == definitionId) {
                CacheService.getParentDefinition().push(definition);
                return definition.childDefinitions[i];
            }
        }

        for (i = 0; i < definition.childDefinitions.length; ++i) {
            const result = getCurrentDefinition(definition.childDefinitions[i], definitionId);
            if (result !== null) {
                CacheService.getParentDefinition().push(definition);
                return result;
            }
        }

        return null;
    }

    return {
        init: function () {
            SleuthService.removeSleuthData();
            $rootScope.clearSearchBar();
        },
        syncDefinition: function (definitionId) {
            // Ignore when page go from tech to distributor and when user refresh page.
            if (definitionId !== undefined && CacheService.getDefinition() !== undefined) {
                if (CacheService.getDefinition().id != definitionId) {
                    if (!hasSyncByParent(definitionId)) {
                        if (!hasSyncByChildren(definitionId)) {
                            syncFromRootDefinitions(definitionId);
                        }
                    }
                }
            }
        },
        findNextDefinition: function (definition, parent) {
            const results = {
                current: {},
                parent: {}
            };
            while (definition.childDefinitions.length === 1) {
                CacheService.storeParentDefinition(parent);
                parent = definition;
                definition = definition.childDefinitions[0];
            }
            results.current = definition;
            results.parent = parent;
            return results;
        },
        openMenu: function () {
            const rootDefinitions = CacheService.getAllDefinitions();

            for (let i = 0; i < rootDefinitions.length; ++i) {

                if (CacheService.getDefinition() && hasChildDefinition(rootDefinitions[i], CacheService.getDefinition())) {
                    rootDefinitions[i].setActiveClass = true;
                    rootDefinitions[i].showParameters = true;
                    break;
                }
            }
        },
        closeMenu: function () {
            const rootDefinitions = CacheService.getAllDefinitions();
            for (let i = 0; i < rootDefinitions.length; ++i) {
                rootDefinitions[i].setActiveClass = false;
                rootDefinitions[i].showParameters = false;
            }
        },
        syncSleuth: function (oldUrl) {
            const oldSearch = getParameterByName('search', oldUrl);
            const newSearch = $location.search().search;

            console.log('oldSearch: ' + oldSearch + ' newSearch: ' + newSearch);
            console.log('SleuthData: ' + SleuthService.getSleuthData());

            // const oldParmValueIds = getParamValueIds(oldUrl);
            // const newParmValueIds = $location.search().parmValueIds ? $location.search().parmValueIds : [];
            //
            if (oldSearch !== newSearch) {
                if (newSearch === undefined) {
                    SleuthService.removeSleuthData();
                    CacheService.storeOriginalQueryInput(undefined);
                } else if (SleuthService.getSleuthData() !== undefined &&
                    SleuthService.getSleuthData().searchInput !== newSearch) {

                    CacheService.storeOriginalQueryInput(newSearch);

                    SpinnerLoadingService.showLoading();

                    const queryParameter = {
                        input: newSearch,
                        targetMfgs: []
                    };

                    QueryApiService.executeQueryByRaw(queryParameter, function (results) {
                        // $location.skipClear = false;
                        if ((results.message == null && (results.detectedDefinitions == null || results.detectedDefinitions.length === 0)) || // error occurred on sleuth
                            (results.message.type === 'ERROR')) { // sleuth return no results
                            let message;
                            if (results.message == null) {
                                message = $translate.instant('message__errorText').valueOf();
                            } else {
                                message = results.message.text;
                            }
                            SleuthService.sendMessageToUser(
                                {
                                    message: {
                                        text: message,
                                        type: 'error'
                                    }
                                },
                                $location.path()
                            );

                        } else {
                            SleuthService.storeSleuthData(results);
                            SleuthService.buildQueryData(results, function searchDef(definition) {
                                var possibleFoundDefinition = null;
                                if ($location.search().id) {
                                    if (definition.id == $location.search().id) {
                                        possibleFoundDefinition = definition;
                                    } else if (definition.childDefinitions.length > 0) {
                                        for (var i = 0; i < definition.childDefinitions.length; ++i) {
                                            possibleFoundDefinition = searchDef(definition.childDefinitions[i]);
                                            if (possibleFoundDefinition) {
                                                CacheService.getParentDefinition().unshift(definition);
                                                break;
                                            }
                                        }
                                    }
                                    return possibleFoundDefinition;
                                }
                                return definition;
                            });
                        }
                        SpinnerLoadingService.hideLoading();
                    }, function (error) {
                        console.log('There was an error in the Search controller.', error);
                        // var e = new Error('SleuthError');
                        // var stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
                        //     .replace(/^\s+at\s+/gm, '')
                        //     .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
                        //     .split('\n');
                        // console.error(stack);
                        SpinnerLoadingService.hideLoading();
                    });
                }
            } //else if($location.path() === '/browsing' && isParmValueIdsDifferent(oldParmValueIds, newParmValueIds)) {
            //     if (newParmValueIds.length === 0) {
            //         SleuthService.removeSleuthData();
            //         CacheService.storeOriginalQueryInput(undefined);
            //     } else {
            //
            //         SpinnerLoadingService.showLoading();
            //
            //         const queryParameterValues = {
            //             targetMfgs: [],
            //             targetDefinitionIds: [],
            //             values: [],
            //             parameterValueIds: newParmValueIds
            //         };
            //
            //         queryParameterValues.targetDefinitionIds.push($location.search().id);
            //         queryParameterValues.parameterValueIds = newParmValueIds;
            //         newParmValueIds.forEach(function (parameterValueId) {
            //             const queryParameterValue = {
            //                 parameterValueIds: [parameterValueId],
            //                 oldParameterValueIds: [parameterValueId]
            //             };
            //             queryParameterValues.values.push(queryParameterValue);
            //         });
            //
            //         QueryApiService.executeParameterValueSearch(queryParameterValues, function (results) {
            //             // $location.skipClear = false;
            //             if ((results.message == null && results.detectedDefinition == null) || // error occurred on sleuth
            //                 (results.message.type === 'ERROR')) { // sleuth return no results
            //                 let message;
            //                 if (results.message == null) {
            //                     message = $translate.instant('message__errorText').valueOf();
            //                 } else {
            //                     message = results.message.text;
            //                 }
            //                 SleuthService.sendMessageToUser(
            //                     {
            //                         message: {
            //                             text: message,
            //                             type: 'error'
            //                         }
            //                     },
            //                     $location.path()
            //                 );
            //
            //             } else {
            //                 SleuthService.storeSleuthData(results);
            //                 SleuthService.buildQueryData(results, function searchDef(definition) {
            //                     var possibleFoundDefinition = null;
            //                     if ($location.search().id) {
            //                         if (definition.id == $location.search().id) {
            //                             possibleFoundDefinition = definition;
            //                         } else if (definition.childDefinitions.length > 0) {
            //                             for (var i = 0; i < definition.childDefinitions.length; ++i) {
            //                                 possibleFoundDefinition = searchDef(definition.childDefinitions[i]);
            //                                 if (possibleFoundDefinition) {
            //                                     CacheService.getParentDefinition().unshift(definition);
            //                                     break;
            //                                 }
            //                             }
            //                         }
            //                         return possibleFoundDefinition;
            //                     }
            //                     return definition;
            //                 });
            //             }
            //             SpinnerLoadingService.hideLoading();
            //         }, function (error) {
            //             console.log('There was an error in the Search controller.', error);
            //             SpinnerLoadingService.hideLoading();
            //         });
            //
            //     }
            // }

        }
    };
}
